import IColors from '../../../types/interfaces/color';

/**
 * Color palette configuration for the Tivify theme.
 * Defines all color values used throughout the application including backgrounds, borders, buttons, modals, progress indicators, and text colors.
 */
const Colors: IColors = {
  background: '#000000',
  border: {
    channel: '#7E7E7E', 
    floatingMenu: '#FFFFFFCC',
    poster: '#707070',
    rating: '#00D0FE'
  },
  button: {
    floatingMenu: 'rgba(255, 255, 255, 0.90)',
    text: '#000000',
  },
  dark: '#1f1f1f',
  darkGrey: '#636363',
  dark07: 'rgba(31, 31, 31, 0.7)',
  gradient: '#4e4e4e',
  gradients: { modalButton: ['rgb(255, 190, 108)', 'rgb(208, 116, 0)'] },
  green: '#2BEEC2',
  grey: '#DDDDDD',
  light: '#ffffff',
  key: '#16dbae',
  keyBg: '#646464',
  menu: {
    border: "#565656",
    icon: {
      focused: '#50E3C2',
      unfocused: '#ffffff',
    },
    text: '#ffffff',
  },
  modal: {
    background: 'rgba(0, 0, 0, 0.87)',
    button: {
      border: '#d07400',
      gradient: '#ffbe6c',
      light: '#ffffff',
      text: '#000000',
    },
    dial: {
      background: '#2e2e2e',
      border: '#939393',
    },
    grey: '#8e8d8d',
    title: '#50e3c2',
  },
  progress: {
    fillNextEpisode: '#50E3C2',
    fillFastEvent: '#E71114',
    fill: '#2BEEC2',
    live: '#d0021b',
    ad: '#E80303',
  },
  secondaryButton: {
    gradient:
      'linear-gradient(180deg, rgba(255, 190, 108, 1) 0%, rgba(208, 116, 0, 1) 100%)',
  },
  selector: "#50E3C2",
  promo: '#1dd86c',
  text: '#ffffff',
};

export default Colors;
